// extracted by mini-css-extract-plugin
export default {"modalContainer":"ActivityLoader_modalContainer__kLF+o"};